import { FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER } from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    next: null,
    totalcount:0
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.REQUEST:
            return { ...state, isLoading: true };
        case FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.FAILURE:
            return { ...state, isLoading: false };
        case FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.SUCCESS:
            return {
                ...state,
                data: [...action?.obj?.data],
                totalcount:action?.obj?.totalcount?action?.obj?.totalcount:0,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default reducer;
